import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Avatar,
  Chip,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { StyledTableRow } from '../styled/TableComponents';
import { formatTimestamp } from '../../../utils/dateUtils';
import { getCategoryColor } from '../../../utils/categoryUtils';

const BlogsTable = ({ blogs, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <TableContainer component={Paper} sx={{ boxShadow: 1, borderRadius: 2 }}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Loading blogs...
          </Typography>
        </Box>
      </TableContainer>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ boxShadow: 1, borderRadius: 2 }}>
      <Table>
        <TableHead sx={{ bgcolor: '#f8fafc' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Image</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Author</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Published</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {blogs.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} align="center">
                <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>
                  No blogs found
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            blogs.map((blog) => (
              <StyledTableRow key={blog.id}>
                <TableCell>
                  <Avatar
                    src={blog.imageUrl}
                    alt={blog.title}
                    variant="rounded"
                    sx={{ width: 56, height: 56 }}
                  />
                </TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      maxWidth: '400px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {blog.title}
                  </Typography>
                  {blog.betaVersion && (
                    <Chip
                      label="Beta"
                      size="small"
                      color="warning"
                      sx={{
                        height: 18,
                        fontSize: '0.7rem',
                        mt: 0.5,
                      }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{blog.author}</Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={blog.category || 'Uncategorized'}
                    size="small"
                    sx={{
                      backgroundColor: getCategoryColor(blog.category),
                      color: 'white',
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {formatTimestamp(blog.publishedDate)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Edit Blog">
                      <IconButton
                        size="small"
                        sx={{ color: '#232536' }}
                        onClick={() => onEdit(blog)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Blog">
                      <IconButton
                        size="small"
                        sx={{ color: '#ef4444' }}
                        onClick={() => onDelete(blog)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </StyledTableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BlogsTable;
